import { useParams } from "react-router";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { NotFoundInAppPage } from "@/components/pages_public/404/NotFound";
import { useRoleplayQuery } from "@/graphql";

import { ScenarioCreateContent } from "./ScenarioCreateContent";

function ScenarioCreatePageContainer() {
  const { slug } = useParams();
  const { data, loading } = useRoleplayQuery({
    skip: !slug,
    fetchPolicy: "cache-and-network",
    variables: { slug },
  });

  const roleplay = data?.roleplay;

  if (slug && !loading && data && !roleplay) {
    return <NotFoundInAppPage />;
  }

  const title = roleplay?.name
    ? `${roleplay.name} - Create Scenario`
    : "Create Scenario";
  return (
    <>
      <SEOHead title={`${title} - Exec`} />
      <Nav pageLoading={loading} />
      <ScenarioCreateContent roleplay={roleplay} loading={loading} />
    </>
  );
}

export function ScenarioCreatePage() {
  return (
    <Authenticate maxWidth="100%" layout="full">
      <ScenarioCreatePageContainer />
    </Authenticate>
  );
}
